import React, { FC } from 'react';
import styled from 'styled-components';
import { Skeleton } from '../../Skeleton/Skeleton';
import { Typography } from '../../Typography';
import { DATA_TABLE_TOOLBAR_HEIGHT_PX } from '../utils/DataTableHeights';
import { useFetchingState } from './DataTableQuickReports/utils/useFetchingState';

export const Message: FC<React.PropsWithChildren<{ message: string | undefined }>> = ({ message }) => {
  const { isDataLoading } = useFetchingState();
  return (
    <StyledToolbarMessage data-test="data-table-message" $isFetching={isDataLoading}>
      {isDataLoading ? (
        <Skeleton width={200} height={18} variant="rect" />
      ) : (
        <Typography dataTest="message" noWrap>
          {message}
        </Typography>
      )}
    </StyledToolbarMessage>
  );
};

export const StyledToolbarMessage = styled.div<{ $isFetching?: boolean }>`
  position: relative;
  height: ${DATA_TABLE_TOOLBAR_HEIGHT_PX};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: width 0.15s ease-in-out;

  & > span {
    display: inline-block;
  }

  .MuiTypography-root {
    display: inline-block;
    color: ${({ theme, $isFetching }) => ($isFetching ? 'rgba(0, 0, 0, 0)' : theme.colorOnSurface)};
  }
`;

export const StyledToolbarMessageSkeleton = styled.div`
  height: 100%;
  width: 100%;
  min-width: 150px;
`;
